module.exports = __webpack_public_path__ + "static/media/Tom Burkewitz‎ 02.2779a0df.jpg";